<script>
    import DatePicker from 'vue2-datepicker';
    import Radio from '~componentes/Radio.vue';
    import converterMoeda from '~js/converter-moeda';
    import solicitacaoBolsaServico from '../../servico';

    export default {
        components: { Radio, DatePicker },
        props: {
            solicitacao: {
                type: Object,
                required: true
            },
            parcelas: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                configuracao: this.$storage.configuracao(),
                carregando: false,
                diaBase: 25,
                diasUteisAntecedencia: 5,
                dataLimiteUltimaParcela: '',
                projetoInicio: '',
                projetoTermino: '',
                projetoSemTermino: false,
                assinaturaGerada: null,
                cronogramaAceito: null,
                datasConfirmadas: {},
            }
        },
        computed: {
            assinaturaAtual() {
                const s = this.solicitacao;
                const idProjeto = s.projeto ? s.projeto.idProjeto : null;

                return [idProjeto, s.dataVigenciaInicio, s.dataVigenciaFim, s.valorContrato, s.competenciaProvisao].join('|');
            },
            desatualizado() {
                if (this.parcelas.length === 0) return false;

                if (this.assinaturaGerada === null) return false;

                return this.assinaturaGerada !== this.assinaturaAtual;
            },
            faltaVigencia() {
                return !this.solicitacao.dataVigenciaInicio
                    || !this.solicitacao.dataVigenciaFim
                    || !this.solicitacao.valorContrato;
            },
            semProjeto() {
                return !this.solicitacao.projeto || !this.solicitacao.projeto.idProjeto;
            },
            totalCronograma() {
                return this.parcelas.reduce((total, parcela) => {
                    return total + (converterMoeda.paraDolar(parcela.valorParcela) || 0);
                }, 0);
            },
            totalFormatado() {
                return converterMoeda.paraReal(this.totalCronograma);
            },
            periodoProjeto() {
                if (!this.projetoInicio && !this.projetoTermino)
                    return '';

                return `${this.projetoInicio || '---'} a ${this.projetoTermino || '---'}`;
            },
            periodoContrato() {
                const inicio = this.solicitacao.dataVigenciaInicio;
                const fim = this.solicitacao.dataVigenciaFim;

                if (!inicio && !fim)
                    return '';

                return `${inicio || '---'} a ${fim || '---'}`;
            },
            valorMaximo() {
                return converterMoeda.paraDolar(this.solicitacao.valorContrato) || 0;
            },
            dataMinima() {
                const candidatas = [
                    moment(this.solicitacao.dataVigenciaInicio, 'DD/MM/YYYY'),
                    moment(this.projetoInicio, 'DD/MM/YYYY'),
                ].filter(data => data.isValid());

                return candidatas.length > 0 ? moment.max(candidatas) : null;
            },
            dataMaxima() {
                const candidatas = [
                    moment(this.dataLimiteUltimaParcela, 'DD/MM/YYYY'),
                    moment(this.projetoTermino, 'DD/MM/YYYY'),
                ].filter(data => data.isValid());

                return candidatas.length > 0 ? moment.min(candidatas) : null;
            },
            presoAoMes() {
                return this.cronogramaAceito !== false;
            },
            intervaloLivre() {
                const minima = this.dataMinima;
                const maxima = this.dataMaxima;

                if (!minima && !maxima) return '';

                return `${minima ? minima.format('DD/MM/YYYY') : '---'} a ${maxima ? maxima.format('DD/MM/YYYY') : '---'}`;
            },
        },
        methods: {
            validar(valido) {
                if (!valido) throw new Error("validacao com erro");

                return this.$validator.validateAll();
            },
            tipoDaParcela(indice) {
                if (indice === 0) return 'Primeira';
                if (indice === this.parcelas.length - 1) return 'Última';

                return 'Mensal';
            },
            travada(indice) {
                if (this.cronogramaAceito === false) return false;

                return indice > 0 && indice < this.parcelas.length - 1;
            },
            dataComoDate(parcela) {
                const data = moment(parcela.dataParcelaTexto, 'DD/MM/YYYY');

                return data.isValid() ? data.toDate() : null;
            },
            limiteInferior(indice) {
                const candidatos = [];

                if (this.dataMinima) candidatos.push(this.dataMinima.clone());

                if (indice > 0) {
                    const anterior = moment(this.parcelas[indice - 1].dataParcelaTexto, 'DD/MM/YYYY');

                    if (anterior.isValid()) candidatos.push(anterior);
                }

                if (this.presoAoMes) {
                    const base = moment(this.parcelas[indice].dataParcelaTexto, 'DD/MM/YYYY');

                    if (base.isValid()) candidatos.push(base.clone().startOf('month'));
                }

                return candidatos.length > 0 ? moment.max(candidatos).toDate() : '';
            },
            limiteSuperior(indice) {
                const candidatos = [];

                if (this.dataMaxima) candidatos.push(this.dataMaxima.clone());

                if (indice < this.parcelas.length - 1) {
                    const proxima = moment(this.parcelas[indice + 1].dataParcelaTexto, 'DD/MM/YYYY');

                    if (proxima.isValid()) candidatos.push(proxima);
                }

                const base = moment(this.parcelas[indice].dataParcelaTexto, 'DD/MM/YYYY');

                if (this.presoAoMes && base.isValid())
                    candidatos.push(base.clone().date(Math.min(this.diaBase, base.daysInMonth())));

                return candidatos.length > 0 ? moment.min(candidatos).toDate() : '';
            },
            diaIndisponivel(data) {
                return data.getDate() > this.diaBase;
            },
            selecionarData(indice, valor) {
                if (!valor) return;

                const nova = moment(valor);

                if (!nova.isValid()) return;

                this.aplicarData(indice, nova);
            },
            aplicarData(indice, nova) {
                const parcela = this.parcelas[indice];

                const recusar = mensagem => {
                    parcela.dataParcelaTexto = this.datasConfirmadas[indice] || parcela.dataParcelaTexto;
                    this.$forceUpdate();
                    this.$swal('', mensagem, 'info');
                };

                if (nova.date() > this.diaBase)
                    return recusar(`O pagamento não pode passar do dia ${this.diaBase}.`);

                if (this.dataMinima && nova.isBefore(this.dataMinima, 'day'))
                    return recusar(`O pagamento não pode ser anterior a ${this.dataMinima.format('DD/MM/YYYY')}.`);

                if (this.dataMaxima && nova.isAfter(this.dataMaxima, 'day'))
                    return recusar(`O pagamento não pode passar de ${this.dataMaxima.format('DD/MM/YYYY')}.`);

                const anterior = indice > 0
                    ? moment(this.parcelas[indice - 1].dataParcelaTexto, 'DD/MM/YYYY')
                    : null;

                if (anterior && anterior.isValid() && nova.isBefore(anterior, 'day'))
                    return recusar(`A parcela ${indice + 1} não pode ser anterior à parcela ${indice}.`);

                const proxima = indice < this.parcelas.length - 1
                    ? moment(this.parcelas[indice + 1].dataParcelaTexto, 'DD/MM/YYYY')
                    : null;

                if (proxima && proxima.isValid() && nova.isAfter(proxima, 'day'))
                    return recusar(`A parcela ${indice + 1} não pode ser posterior à parcela ${indice + 2}.`);

                parcela.dataParcelaTexto = nova.format('DD/MM/YYYY');

                this.marcarEditada(indice);
                this.$forceUpdate();
            },
            competenciaDe(parcela) {
                if (!parcela.competenciaMes || !parcela.competenciaAno)
                    return '---';

                return `${('0' + parcela.competenciaMes).slice(-2)}/${parcela.competenciaAno}`;
            },
            gerar() {
                if (this.semProjeto) {
                    this.$swal('', 'Selecione o projeto antes de gerar o cronograma.', 'info');
                    return;
                }

                if (this.faltaVigencia) {
                    this.$swal('', 'Informe a vigência e o valor mensal na aba "Dados do contrato" antes de gerar o cronograma.', 'info');
                    return;
                }

                if (this.parcelas.length > 0) {
                    this.$swal({
                        title: 'Gerar novamente?',
                        text: 'O cronograma atual será substituído, inclusive os ajustes manuais.',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Gerar',
                        cancelButtonText: 'Cancelar',
                    }).then(() => this.solicitarSugestao()).catch(() => { });

                    return;
                }

                this.solicitarSugestao();
            },
            solicitarSugestao() {
                this.carregando = true;

                return solicitacaoBolsaServico
                    .sugerirParcelas({
                        idProjeto: this.solicitacao.projeto.idProjeto,
                        dataVigenciaInicio: this.paraIso(this.solicitacao.dataVigenciaInicio),
                        dataVigenciaFim: this.paraIso(this.solicitacao.dataVigenciaFim),
                        valorMensal: converterMoeda.paraDolar(this.solicitacao.valorContrato) || 0,
                        competencia: this.solicitacao.competenciaProvisao || 1,
                    })
                    .then(cronograma => {
                        this.aplicarCronograma(cronograma);
                        this.carregando = false;
                    })
                    .catch(() => {
                        this.carregando = false;
                        this.$swal('', 'Não foi possível gerar o cronograma.', 'error');
                    });
            },
            aplicarCronograma(cronograma) {
                this.diaBase = cronograma.diaBase;
                this.diasUteisAntecedencia = cronograma.diasUteisAntecedencia;
                this.dataLimiteUltimaParcela = this.paraBr(cronograma.dataLimiteUltimaParcela);
                this.projetoInicio = this.paraBr(cronograma.projetoInicio);
                this.projetoTermino = this.paraBr(cronograma.projetoTermino);
                this.projetoSemTermino = cronograma.projetoSemTermino;

                const novas = (cronograma.parcelas || []).map(parcela => ({
                    numeroParcela: parcela.numeroParcela,
                    tipoParcela: parcela.tipoParcela,
                    dataParcelaTexto: this.paraBr(parcela.dataParcela),
                    valorParcela: converterMoeda.paraReal(parcela.valorParcela),
                    quantidadeControle: parcela.quantidadeControle,
                    competenciaMes: parcela.competenciaMes,
                    competenciaAno: parcela.competenciaAno,
                    editadaManualmente: false,
                }));

                this.assinaturaGerada = this.assinaturaAtual;
                this.cronogramaAceito = null;

                const datas = {};

                novas.forEach((parcela, indice) => {
                    datas[indice] = parcela.dataParcelaTexto;
                });

                this.datasConfirmadas = datas;

                this.$emit('update:parcelas', novas);
            },
            carregarLimites() {
                if (!this.solicitacao.projeto || !this.solicitacao.projeto.idProjeto)
                    return;

                if (!this.solicitacao.dataVigenciaInicio || !this.solicitacao.dataVigenciaFim)
                    return;

                return solicitacaoBolsaServico
                    .sugerirParcelas({
                        idProjeto: this.solicitacao.projeto.idProjeto,
                        dataVigenciaInicio: this.paraIso(this.solicitacao.dataVigenciaInicio),
                        dataVigenciaFim: this.paraIso(this.solicitacao.dataVigenciaFim),
                        valorMensal: converterMoeda.paraDolar(this.solicitacao.valorContrato) || 0,
                        competencia: this.solicitacao.competenciaProvisao || 1,
                    })
                    .then(cronograma => {
                        this.diaBase = cronograma.diaBase;
                        this.diasUteisAntecedencia = cronograma.diasUteisAntecedencia;
                        this.dataLimiteUltimaParcela = this.paraBr(cronograma.dataLimiteUltimaParcela);
                        this.projetoInicio = this.paraBr(cronograma.projetoInicio);
                        this.projetoTermino = this.paraBr(cronograma.projetoTermino);
                        this.projetoSemTermino = cronograma.projetoSemTermino;
                    })
                    .catch(() => { });
            },
            competenciaAlterada() {
                if (this.semProjeto || this.faltaVigencia)
                    return;

                if (this.parcelas.length === 0) {
                    this.carregarLimites();
                    return;
                }

                this.solicitarSugestao();
            },
            marcarEditada(indice) {
                const parcela = this.parcelas[indice];

                if (!parcela) return;

                parcela.editadaManualmente = true;

                this.$set(this.datasConfirmadas, indice, parcela.dataParcelaTexto);
            },
            guardarDatas() {
                const datas = {};

                this.parcelas.forEach((parcela, indice) => {
                    datas[indice] = parcela.dataParcelaTexto;
                });

                this.datasConfirmadas = datas;
            },
            liberarAjuste() {
                if (this.parcelas.length === 0) return;

                this.guardarDatas();
                this.cronogramaAceito = false;
            },
            aceitarCronograma() {
                if (this.cronogramaAceito === true) return;

                if (this.cronogramaAceito === null) {
                    this.cronogramaAceito = true;
                    return;
                }

                const editadas = this.parcelas.some(parcela => parcela.editadaManualmente);

                if (!editadas) {
                    this.cronogramaAceito = true;
                    return;
                }

                this.$swal({
                    title: 'Voltar ao cronograma sugerido?',
                    text: 'Os ajustes manuais das parcelas serão descartados.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Voltar ao sugerido',
                    cancelButtonText: 'Continuar ajustando',
                }).then(() => {
                    this.cronogramaAceito = true;
                    this.solicitarSugestao();
                }).catch(() => { });
            },
            arredondar(valor) {
                return Math.round((+valor || 0) * 100) / 100;
            },
            alterarValor(indice) {
                const parcela = this.parcelas[indice];

                if (!parcela) return;

                this.marcarEditada(indice);

                const maximo = this.arredondar(this.valorMaximo);
                const valor = this.arredondar(converterMoeda.paraDolar(parcela.valorParcela) || 0);

                if (maximo > 0 && valor - maximo > 0.005) {
                    parcela.valorParcela = converterMoeda.paraReal(maximo);

                    this.$swal('', `O valor da parcela não pode ultrapassar o valor mensal do contrato (${converterMoeda.paraReal(maximo)}).`, 'info');
                }
            },
            paraIso(data) {
                if (!data) return null;

                const convertida = moment(data, 'DD/MM/YYYY');

                return convertida.isValid() ? convertida.format('YYYY-MM-DD') : null;
            },
            paraBr(data) {
                if (!data) return '';

                const convertida = moment(data);

                return convertida.isValid() ? convertida.format('DD/MM/YYYY') : '';
            },
        },
        mounted() {
            this.carregarLimites();
        },
        watch: {
            'solicitacao.dataVigenciaFim': 'carregarLimites',
            'solicitacao.projeto.idProjeto': 'carregarLimites',
            'solicitacao.competenciaProvisao': 'competenciaAlterada',
            parcelas: {
                immediate: true,
                handler(novas) {
                    if (!novas || novas.length === 0) return;

                    if (this.assinaturaGerada === null) {
                        this.assinaturaGerada = this.assinaturaAtual;

                        const ajustadas = novas.some((parcela, indice) => {
                            return parcela.editadaManualmente && indice > 0 && indice < novas.length - 1;
                        });

                        this.cronogramaAceito = !ajustadas;
                    }

                    this.guardarDatas();
                }
            }
        }
    }
</script>

<template>
    <div>

        <div class="alert alert-danger" v-if="desatualizado">
            <strong><i class="fa fa-exclamation-triangle"></i> Os dados do contrato mudaram depois que o cronograma foi montado.</strong>
            <br>
            Alterar o <strong>projeto</strong>, a <strong>vigência</strong> ou o <strong>valor mensal</strong>
            invalida as parcelas abaixo. Clique em <strong>Gerar cronograma</strong> para refazê-las antes de salvar.
        </div>

        <div class="alert alert-warning" v-if="semProjeto || faltaVigencia">
            <i class="fa fa-info-circle"></i>
            Para montar o cronograma, informe antes o <strong>projeto</strong> (aba Dados cadastrais) e a
            <strong>vigência</strong> e o <strong>valor mensal</strong> (aba Dados do contrato).
        </div>

        <div class="alert alert-info">
            <p v-if="periodoContrato">
                <strong>Vigência do contrato:</strong> {{ periodoContrato }}
                <span v-if="solicitacao.valorContrato">
                    &mdash; valor mensal {{ solicitacao.valorContrato }}
                </span>
            </p>
            <p v-else>
                <strong>Vigência do contrato:</strong> informe na aba "Dados do contrato".
            </p>
            <p>
                <strong>Pagamento sugerido:</strong> dia {{ diaBase }} do mês seguinte ao mês trabalhado,
                com o valor mensal do contrato. A primeira e a última parcela podem ser ajustadas
                (data e valor, até o mensal do contrato). Para corrigir as demais, escolha
                <strong>Ajustar as parcelas</strong> no rodapé.
            </p>
            <p v-if="periodoProjeto">
                <strong>Execução do projeto:</strong> {{ periodoProjeto }}
            </p>
            <p v-if="dataLimiteUltimaParcela">
                <strong>Última parcela permitida:</strong> {{ dataLimiteUltimaParcela }}
                ({{ diasUteisAntecedencia }} dias úteis antes do término do projeto)
            </p>
            <p v-if="projetoSemTermino">
                O projeto não tem data de término cadastrada, então não há limite para a última parcela.
            </p>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <label class="control-label">Competência das provisões</label>

                    <div>
                        <radio v-model="solicitacao.competenciaProvisao"
                               name="competenciaProvisao"
                               :selected-value="1"
                               :inline="true"
                               type="success">
                            Mês anterior
                        </radio>

                        <radio v-model="solicitacao.competenciaProvisao"
                               name="competenciaProvisao"
                               :selected-value="2"
                               :inline="true"
                               type="success">
                            Mês vigente
                        </radio>
                    </div>

                    <small class="help-block">
                        Define apenas a referência ("Ref. MM/AAAA") de cada provisão: o mês trabalhado ou o mês do
                        pagamento. As datas, os valores e a quantidade de parcelas não mudam.
                    </small>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8">
                <button type="button"
                        class="btn"
                        :class="desatualizado ? 'btn-danger' : 'btn-primary'"
                        @click="gerar"
                        :disabled="carregando || semProjeto || faltaVigencia">
                    <i class="fa fa-refresh" :class="{'fa-spin': carregando}"></i> Gerar cronograma
                </button>
            </div>

            <div class="col-lg-4 text-right">
                <strong>Valor mensal:</strong> {{ solicitacao.valorContrato }}
            </div>
        </div>

        <div class="row" style="margin-top: 15px;">
            <div class="col-lg-12">
                <div>
                    <table class="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 60px;">#</th>
                                <th style="width: 110px;">Tipo</th>
                                <th style="width: 200px;">Data de pagamento</th>
                                <th style="width: 180px;">Valor (R$)</th>
                                <th style="width: 110px;">Ref.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(parcela, indice) in parcelas"
                                :key="indice"
                                :style="{ position: 'relative', zIndex: parcelas.length - indice }">
                                <td class="text-center">{{ indice + 1 }}</td>
                                <td>{{ tipoDaParcela(indice) }}</td>
                                <td>
                                    <span v-if="travada(indice)">{{ parcela.dataParcelaTexto }}</span>

                                    <date-picker v-else
                                                 :value="dataComoDate(parcela)"
                                                 format="DD/MM/YYYY"
                                                 lang="pt-br"
                                                 input-class="form-control"
                                                 :editable="false"
                                                 :clearable="false"
                                                 :append-to-body="true"
                                                 :popup-style="{ zIndex: 3200 }"
                                                 :not-before="limiteInferior(indice)"
                                                 :not-after="limiteSuperior(indice)"
                                                 :disabled-days="diaIndisponivel"
                                                 style="width: 100%"
                                                 @input="valor => selecionarData(indice, valor)">
                                    </date-picker>
                                </td>
                                <td class="text-right">
                                    <span v-if="travada(indice)">{{ parcela.valorParcela }}</span>

                                    <input v-else
                                           type="text"
                                           class="form-control text-right"
                                           :id="'parcela-valor-' + indice"
                                           v-model="parcela.valorParcela"
                                           v-mascara="'moeda'"
                                           @change="alterarValor(indice)">
                                </td>
                                <td>{{ competenciaDe(parcela) }}</td>
                            </tr>

                            <tr v-if="parcelas.length === 0">
                                <td colspan="5" class="text-center">
                                    Nenhuma parcela informada. Clique em <strong>Gerar cronograma</strong>.
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="parcelas.length > 0">
                            <tr>
                                <th colspan="3" class="text-right">Total do cronograma</th>
                                <th class="text-right">{{ totalFormatado }}</th>
                                <th>{{ parcelas.length }} parcela(s)</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>

        <div class="row" v-if="parcelas.length > 0">
            <div class="col-lg-12">
                <div class="well well-sm" :class="{'well-pendente': cronogramaAceito === null}">
                    <p>
                        <strong>Você aceita este cronograma?</strong>
                        <span v-if="cronogramaAceito === null">
                            Escolha uma das opções abaixo para poder salvar a solicitação. A primeira e a última
                            parcela já aceitam ajuste &mdash; você pode alterá-las e mesmo assim aceitar o cronograma.
                        </span>
                        <span v-else-if="cronogramaAceito">
                            Aceito &mdash; só a primeira e a última parcela aceitam ajuste.
                        </span>
                        <span v-else>
                            Em ajuste manual &mdash; todas as parcelas estão liberadas: data entre
                            <strong>{{ intervaloLivre }}</strong> e valor até o valor mensal do contrato.
                        </span>
                    </p>

                    <button type="button"
                            class="btn"
                            :class="cronogramaAceito === true ? 'btn-primary' : 'btn-white'"
                            @click="aceitarCronograma">
                        <i class="fa fa-check"></i> Aceito o cronograma
                    </button>

                    <button type="button"
                            class="btn"
                            :class="cronogramaAceito === false ? 'btn-warning' : 'btn-white'"
                            @click="liberarAjuste">
                        <i class="fa fa-pencil"></i> Ajustar as parcelas
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
    .mx-datepicker {
        width: 100%;
    }

    .well-pendente {
        border-color: #f8ac59;
        border-left: 3px solid #f8ac59;
    }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa/componentes/compartilhado/FormCronogramaParcelas.vue